import React from 'react';

const especificaciones = [
    { categoria: 'Follaje 3D', material: 'HDPE', uso: 'Interior y exterior', formatos: 'Panel' },
    { categoria: 'Follaje Premium', material: 'HDPE', uso: 'Interior y exterior', formatos: 'Panel y rollo' },
    { categoria: 'Follaje Estándar', material: 'LDPE', uso: 'Interior', formatos: 'Panel' },
    { categoria: 'Panel de Flores', material: 'Poliéster', uso: 'Interior', formatos: 'Panel y rollo' },
    { categoria: 'Expandible (Madera y Poliéster)', material: 'Madera y poliéster', uso: 'Interior', formatos: 'Plegable' },
    { categoria: 'Expandible (Madera y HDPE)', material: 'Madera y HDPE', uso: 'Interior y exterior', formatos: 'Plegable' },
    { categoria: 'Lona', material: 'Nylon y poliéster', uso: 'Interior', formatos: 'Lona' }
];

const EspecificacionesFollaje = () => {
    return (
        <section id="especificaciones">
            <div className="container">
                <div className="row justify-content-center mb-2-3">
                    <div className="col-lg-10 text-center">
                        <div className="title-style2 mb-1-6 wow fadeIn" data-wow-delay="100ms">
                            <h2 className="h1">Especificaciones por categoría</h2>
                        </div>
                        <p className="mb-0 text-secondary">
                            Compara material, uso recomendado y formato disponible antes de elegir tu follaje
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="bg-white rounded shadow-sm border p-4 p-lg-5">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Categoría</th>
                                            <th scope="col">Material</th>
                                            <th scope="col">Uso recomendado</th>
                                            <th scope="col">Formatos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {especificaciones.map((fila) => (
                                            <tr key={fila.categoria}>
                                                <th scope="row">{fila.categoria}</th>
                                                <td>{fila.material}</td>
                                                <td>{fila.uso}</td>
                                                <td>{fila.formatos}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EspecificacionesFollaje;